module.exports = __webpack_public_path__ + "img/logo.b2209d12.png";